import { useQuery } from '@tanstack/react-query';
import { m6_2Endpoints } from '../../../endpoints/m6-2';

/**
 * Sessioni atleta filtrate per scope (M6.2 B11.A).
 * scope='all' → backward compat endpoint legacy senza filter.
 */
export function useAthleteSessionsScoped(
  athleteId: string,
  scope: 'all' | 'team' | 'individual' = 'all',
  from?: string,
  to?: string,
  enabled = true,
) {
  return useQuery({
    queryKey: ['m6-2', 'athlete-sessions', athleteId, scope, from, to],
    queryFn: async () => {
      const res = await m6_2Endpoints.getAthleteSessions(athleteId, {
        scope,
        from,
        to,
      });
      return res.data;
    },
    enabled: enabled && !!athleteId,
    staleTime: 60 * 1000,
  });
}
